import { Component,OnInit } from '@angular/core';
import { Service } from '../../../../../class/service';
import { Cookies } from '../../../../../class/cookies';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { QuickSearch } from '../../../../../class/search';
import 'rxjs/add/operator/debounceTime';

@Component({
  selector: 'app-dias-contables',
  templateUrl: './dias-contables.component.html',
  styleUrls: ['./dias-contables.component.css']
})
export class DiasContablesComponent implements OnInit {
	//Mostrar loader
	private state: boolean = false;
	//Mostrar vista del formulario
	private list: boolean = true;
	//Niveles del usuario
	private privileges: Object = {};
	//Accion de guardar y modificar
	private action: String = "Guardar";
	//Id del usuario logueado
	private myId: number = 0;
	//Modelo del buscador y ref del buscador
	private extra: Object = { search: '' };
	private search = new FormControl();
	//Paginacion y mostrar las paginas
	private pagination: Array<any>;
	private pages: Array<number> = [];
	//Variables para mostrar informacion
	private active: boolean = false;
	private message: string = "";
	private type: string = "";
	//Modelo de datos
	private model: Object = {
		fecha:''
	};
	//Referencia del codigo
	private ref: String = "";
	//Para validaer si el codigo existe
	private validarCodigo: number = 0;
	//relacionado con el imput del html	--llave primaria
	private controlPrincipal = new FormControl({value:''});
	

	constructor(private service: Service, private cookies: Cookies) {}

	ngOnInit() {
		//Obtener ell usuario loguedo
		this.myId = this.cookies.getCookie('ChamUserObject')["userprofile"][0]["id"];
		//Validar privilegios
		this.service.PRIVILEGES(this.myId, 'dias_contables-component').subscribe(res => {
			this.privileges = res["privileges"][0];
			if (this.privileges["read"] == 1) {
			} else if (this.privileges["create"] == 1) {
				this.list = false;
				this.action = "Guardar";
				this.state = !this.state;
			}
		}, err => { console.log(err); });
	}

	//Para mostrar mensajes
	private openMd(_msg: string, _type: string): void {
		this.active = true;
		this.message = _msg;
		this.type = _type;
		setTimeout(() => {
			this.active = false;
		}, 4000);
	}

	//Un nuevo registro, iniciando datos
	private NEW(): void {

	}

	//Editar en base al codigo de referencia
	private EDIT(codigo: string): void {
		this.ref = codigo;
		this.action = "Actualizar";
		this.list = false;
		this.getModelById();
	}

	//Para obtener y cargar el registro seleccionado
	private getModelById(): void {
		this.state = !this.state;
		this.service.GET('cargos/' + this.ref, '').subscribe(res => {
			console.log(res);
			this.model = res["show"][0];
			this.state = !this.state;
		}, err => {
			console.log(err);
			this.state = !this.state;
		});
	}

	//Validar si guardar o modificar
	private actionCrud(): void {
		if (this.action.toUpperCase() == "GUARDAR") {
			this.save();
		} else {
			this.update();
		}
	}

	//Para eliminar el registro
	private DELETE(codigo: String): void {

	}

	//Guardar el registro
	private save(): void {
		this.state = !this.state;
        console.log({ data: JSON.stringify(this.model) });
        this.service.POST('diascontables', { data: JSON.stringify(this.model) }).subscribe(res => {
			this.state = !this.state;
		}, err => {
            
			console.log(err);
			this.state = !this.state;
		});
	}

	//Modificar el registro
	private update(): void {
		this.state = !this.state;
		console.log({diascontables: JSON.stringify(this.model) });
		this.service.PUT('diascontables/modificar/' + this.ref.trim(), { diascontables: JSON.stringify(this.model) }).subscribe(res => {
			console.log(res);
			if (res["update"]) {
				this.state = !this.state;
				this.openMd("El registro se ha modificado correctamente", "success");
			} else {
				this.openMd("El registro no se ha podido modificar", "danger");
			}
		}, err => {
			console.log(err);
		});
	}

	//Validar si existe el codigo
	private existeFecha(fecha: String) {
		let data = "&fecha=" + fecha;
		this.service.GET("existeFecha", data).subscribe(res => {
			this.validarCodigo = res["existeFecha"] ? 2 : 1;
		},
			err => { console.log(err) }
		)
	}

}



// WEBPACK FOOTER //
// ./src/app/component/module/archivo/contabilidad/dias-contables/dias-contables.component.ts